export const enum PatientWithStatsMutationNames {
  updatePatientWithStats = 'PATIENT_WITH_STATS_UPDATE_PATIENT_WITH_STATS',
}

export const enum PatientWithStatsActionNames {
  getPatientWithStats = 'PATIENT_WITH_STATS_GET_PATIENT_WITH_STATS',
  getPatientWithStatsById = 'PATIENT_WITH_STATS_GET_PATIENT_WITH_STATS_BY_ID',
}

export const enum PatientWithStatsGetterNames {
  PatientWithStats = 'PATIENT_WITH_STATS_PATIENT_WITH_STATS',
}
